import {
	Card,
	Divider,
	Pagination,
	Button,
	Modal,
	Form,
	Input,
	Select,
	message,
} from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
// import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { getCurrencies } from '../../methods/redux/reducers/currency';
import {
	retrievePaymentGateways,
	createPaymentGateway,
	verifyAccountName,
} from '../../methods/redux/reducers/payment-gateway';
import { getCommercialBanks } from '../../methods/redux/reducers/commercialBank';
import PaymentGatewayItem from './PaymentGatewayItem';
import NativeNumber from '../../component/Numeral';
import remakeQueryString from '../../methods/utils/remake-query-string';

export const Style = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	gap: 1em;
`;
export const MainSection = styled(Card)`
	border-radius: 10px;
	gap: 2em;
`;

export const StyledFormItem = styled(Form.Item)`
	.ant-row {
		display: block;
	}
`;

interface IPaymentGateway {
	_id: string;
	name: string;
	gateWayKey: string;
	localCurrencyId: string;
	singlePayOutLimit: number;
	singleDepositLimit: number;
	depositFeePercentage: number;
	depositFeeFlatAmount: number;
	depositFeeCapAmount: number;
	cashoutFeeFixedAmount: number;
	payoutFeeFlatAmount: number;
	payoutFeePercentage: number;
	payoutFeeCapAmount: number;
	// Add other properties as needed
}

interface ICommercialBank {
	_id: string;
	name: string;
	institutionCode: string;
	// Add other properties as needed
}

const PaymentGateway = () => {
	const dispatch = useAppDispatch();
	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isAccountverifyModalVisible, setIsAccountverifyModalVisible] =
		useState(false);
	const [refresh, setRefresh] = useState(0);
	const [verifyAccountResult, setVerifyAccountResult] = useState<any>(null);


	const [searchParams, setSearchParams] = useSearchParams();
	const { currencies } = useAppSelector((store) => store.currencies);

	const { payementgateways } = useAppSelector((store) => store.paymentGateway);

	const { commercialBanks } = useAppSelector((store) => store.commercialBank);
	
	const paymentGatewayList: IPaymentGateway[] = payementgateways.itemsList;
	const commercialBankList: ICommercialBank[] = commercialBanks.itemsList;
	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
				perPage: String(payementgateways.paginator.perPage),
			});
		}

		dispatch(getCurrencies({}));
		dispatch(
			getCommercialBanks({
				pageId: '1',
				perPage: '1000',
			})
		);
	}, []);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			dispatch(retrievePaymentGateways({ ...queryData }));
		} else {
			dispatch(retrievePaymentGateways(queryData));
			
		}
	}, [searchParams, refresh]);

	const currencySelect = currencies.map((item: any) => ({
		name: item.symbol,
		value: item._id,
	}));


	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
	};

	const handleAccountVerifyCancel = () => {
		setIsAccountverifyModalVisible(false);
		form.resetFields();
	};

	const handleAccountVerify = () => {
		setIsAccountverifyModalVisible(true);
	};

	const submitAccountverify = async (value: any) => {
		setLoading(true);
		try {
			const jobData = {
				accountNumber: value.accountNumber,
				paymentGatewayId: value.paymentGatewayId,
				gatewayKey: value.gatewayKey,
				commercialBankId: value.commercialBankId,
				bankCode: value.bankCode,
			};
			const result = await dispatch(verifyAccountName(jobData));
			if (result.payload === undefined) {
				message.error('Account verification failed');
			} else {
				setVerifyAccountResult(result.payload);
				handleAccountVerifyCancel();
			}
		} catch (error: any) {
			message.error(error?.message || 'An error occurred');
		} finally {
			setLoading(false);
			form.resetFields();
			setRefresh(Math.random());
		}
	};

	const handleSubmit = async (values: any) => {
		try {
			setLoading(true);

			const jobData = {
				name: values.name,
				gateWayKey: values.gateWayKey,
				localCurrencyId: values.localCurrencyId,
				singlePayOutLimit: values.singlePayOutLimit,
				singleDepositLimit: values.singleDepositLimit,
				depositFeePercentage: values.depositFeePercentage,
				depositFeeFlatAmount: values.depositFeeFlatAmount,
				depositFeeCapAmount: values.depositFeeCapAmount,
				cashoutFeeFixedAmount: values.cashoutFeeFixedAmount,
				payoutFeeFlatAmount: values.payoutFeeFlatAmount,
				payoutFeePercentage: values.payoutFeePercentage,
				payoutFeeCapAmount: values.payoutFeeCapAmount,
			};

			await dispatch(createPaymentGateway(jobData));
			handleCancel();
			form.resetFields();
			setRefresh(Math.random());
		} catch (error: any) {
			message.error(error?.response?.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Card>
			<h1>Payment Gateways</h1>
			<div style={{ background: '#f8f8ff', padding: '2px 6px' }}>
				<p>
					Admin can configure payment gateways used for deposits and withdrawals
					on the platform.
				</p>
			</div>
			<div style={{ display: 'flex', gap: '8px' }}>
				<Button
					type="primary"
					onClick={showModal}
					style={{ marginTop: '16px', marginBottom: '10px' }}
				>
					Create Payment Gateway
				</Button>
			</div>
			<div style={{ display: 'flex', gap: '8px' }}>
				<Button
					type="primary"
					onClick={handleAccountVerify}
					style={{ marginTop: '10px', marginBottom: '5px' }}
				>
					Validate Account
				</Button>
			</div>

			{verifyAccountResult && (
				<Card
					style={{
						marginTop: '10px',
						backgroundColor: '#f8f8f8',
					}}
					title="Account Verification Result"
					extra={
						<Button onClick={() => setVerifyAccountResult(null)}>Close</Button>
					}
				>
					<div style={{ marginBottom: '6px' }}>
						<h3>Account Name Enquiry</h3>
						<div
							style={{
								display: 'grid',
								gridTemplateColumns: 'repeat(2, 1fr)',
								gap: '8px',
							}}
						>
							<div>
								<strong>Account Name:</strong>
								<p>{verifyAccountResult?.nameEnquiry?.accountName}</p>
							</div>
							<div>
								<strong>Account Number:</strong>
								<p>{verifyAccountResult?.nameEnquiry?.accountNumber}</p>
							</div>
							<div>
								<strong>Bank Code:</strong>
								<p>{verifyAccountResult?.nameEnquiry?.bankCode}</p>
							</div>
							<div>
								<strong>Provider:</strong>
								<p>{verifyAccountResult?.nameEnquiry?.provider}</p>
							</div>
						</div>
					</div>

					<Divider />

					<div style={{ marginBottom: '5px' }}>
						<h3>Payment Gateway Details</h3>
						<div
							style={{
								display: 'grid',
								gridTemplateColumns: 'repeat(2, 1fr)',
								gap: '12px',
							}}
						>
							<div>
								<strong>Gateway Name:</strong>
								<p>{verifyAccountResult?.paymentGateway?.name}</p>
							</div>
							<div>
								<strong>Gateway Key:</strong>
								<p>{verifyAccountResult?.paymentGateway?.gateWayKey}</p>
							</div>
							<div>
								<strong>Status:</strong>
								<p>{verifyAccountResult?.paymentGateway?.status}</p>
							</div>
							<div>
								<strong>Allow Withdrawal:</strong>
								<p>
									{verifyAccountResult?.paymentGateway?.allowWithdrawal
										? 'Yes'
										: 'No'}
								</p>
							</div>
						</div>
					</div>
				</Card>
			)}

			<br />
			<p>
				Total of{' '}
				<strong>
					<NativeNumber value={payementgateways?.paginator?.itemCount} /> items
				</strong>{' '}
				found
			</p>
			<br />
			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={payementgateways.paginator.itemCount}
				current={payementgateways.paginator.currentPage}
				pageSize={payementgateways.paginator.perPage}
			/>
			<br />
			{payementgateways.itemsList.map((item: any) => (
				<PaymentGatewayItem
					key={item?._id}
					data={item}
					setRefresh={setRefresh}
					currencySelect={currencySelect}
				/>
			))}
			<Divider />
			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={payementgateways.paginator.itemCount}
				current={payementgateways.paginator.currentPage}
				pageSize={payementgateways.paginator.perPage}
				showSizeChanger
				showQuickJumper
			/>
			<Modal
				title="Validate Account"
				visible={isAccountverifyModalVisible}
				onCancel={handleAccountVerifyCancel}
				footer={null}
			>
				<Form form={form} onFinish={submitAccountverify}>
					<StyledFormItem
						name="accountNumber"
						label="Account Number"
						rules={[
							{ required: true, message: 'Please input payment accountNumber' },
						]}
					>
						<Input placeholder="23458564803" />
					</StyledFormItem>

					<StyledFormItem
						name="paymentGatewayId"
						label="Payment Gateway"
						rules={[
							{ required: true, message: 'Please input payment gateway name' },
						]}
					>
						<Select
							style={{ width: '100%' }}
							placeholder="Select a currency"
							onChange={(value: any) => {
								// find selected gateway and set its gateWayKey into the form so submitAccountverify
								// can read value.gatewayKey
								const selected = paymentGatewayList?.find(
									(d: any) => d._id === value
								);
								form.setFieldsValue({
									gatewayKey: selected?.gateWayKey,
								});
							}}
						>
							{paymentGatewayList?.map((data: any) => (
								<Select.Option value={data._id} key={data._id}>
									{data.gateWayKey}
								</Select.Option>
							))}
						</Select>
					</StyledFormItem>

					<StyledFormItem
						name="commercialBankId"
						label="Commercial Bank"
						rules={[
							{ required: true, message: 'Please input commercial bank' },
						]}
					>
						<Select
							style={{ width: '100%' }}
							placeholder="Select a bank"
							onChange={(value: any) => {
								// find selected bank and set its institutionCode into the form so submitAccountverify
								// can read value.bankCode
								const record = commercialBankList?.find(
									(d: any) => d._id === value
								);
								form.setFieldsValue({
									bankCode: record?.institutionCode,
								});
							}}
						>
							{commercialBankList?.map((data: any) => (
								<Select.Option value={data._id} key={data._id}>
									{data.name}
								</Select.Option>
							))}
						</Select>
					</StyledFormItem>

					{/* hidden fields to hold the gatewayKey and bankCode for submission */}
					<StyledFormItem name="gatewayKey" style={{ display: 'none' }}>
						<Input />
					</StyledFormItem>
					<StyledFormItem name="bankCode" style={{ display: 'none' }}>
						<Input />
					</StyledFormItem>
					<Form.Item>
						<Button type="primary" htmlType="submit" loading={loading}>
							{loading ? 'Validating...' : 'Validate Account'}
						</Button>
						<Button
							onClick={handleAccountVerifyCancel}
							style={{ marginLeft: '8px' }}
						>
							Cancel
						</Button>
					</Form.Item>
				</Form>
			</Modal>
			{/* Modal for Creating a Payment gateway */}
			<Modal
				title="Create Payment Gateway"
				visible={isModalVisible}
				onCancel={handleCancel}
				footer={null}
			>
				<Form form={form} onFinish={handleSubmit}>
					<StyledFormItem
						name="name"
						label="name"
						rules={[
							{ required: true, message: 'Please input payment gateway name' },
						]}
					>
						<Input placeholder="Bell Bank" />
					</StyledFormItem>

					<StyledFormItem
						name="gateWayKey"
						label="gateWay Key"
						rules={[
							{ required: true, message: 'Please input payment gateway key' },
						]}
					>
						<Input placeholder="BELLBANK" />
					</StyledFormItem>

					<StyledFormItem
						name="localCurrencyId"
						label="Local Currency"
						rules={[
							{ required: true, message: 'Please input the local currency!' },
						]}
					>
						<Select style={{ width: '100%' }} placeholder="Select a currency">
							{currencies?.map((currency: any) => (
								<Select.Option value={currency._id} key={currency._id}>
									{currency.symbol}
								</Select.Option>
							))}
						</Select>
					</StyledFormItem>

					<StyledFormItem
						name="singlePayOutLimit"
						label="Insert Single Payout Limit"
						rules={[{ required: true, message: 'Please input limit!' }]}
					>
						<Input placeholder="e.g., 1000" />
					</StyledFormItem>

					<StyledFormItem
						name="singleDepositLimit"
						label="Insert Single Deposit Limit"
						rules={[
							{ required: true, message: 'Please input single deposit limit!' },
						]}
					>
						<Input placeholder="e.g., 1000" />
					</StyledFormItem>

					<StyledFormItem
						name="depositFeePercentage"
						label="Insert Deposit Fee Percentage"
						rules={[
							{
								required: true,
								message: 'Please input deposit fee percentage!',
							},
						]}
					>
						<Input placeholder="e.g., 5" />
					</StyledFormItem>

					<StyledFormItem
						name="depositFeeFlatAmount"
						label="Insert Deposit Fee Flat Amount"
						rules={[
							{
								required: true,
								message: 'Please input deposit fee flat amount!',
							},
						]}
					>
						<Input placeholder="e.g., 600" />
					</StyledFormItem>

					<StyledFormItem
						name="depositFeeCapAmount"
						label="Insert Deposit Fee Cap Amount"
						rules={[
							{
								required: true,
								message: 'Please input deposit fee cap amount!',
							},
						]}
					>
						<Input placeholder="e.g., 50" />
					</StyledFormItem>

					<StyledFormItem
						name="cashoutFeeFixedAmount"
						label="Insert Cashout Fee Fixed Amount"
						rules={[
							{
								required: true,
								message: 'Please input cashout fee fixed amount!',
							},
						]}
					>
						<Input placeholder="e.g., 33" />
					</StyledFormItem>

					<StyledFormItem
						name="payoutFeeFlatAmount"
						label="Insert Payout Fee Flat Amount"
						rules={[
							{
								required: true,
								message: 'Please input payout fee flat amount!',
							},
						]}
					>
						<Input placeholder="e.g., 10" />
					</StyledFormItem>

					<StyledFormItem
						name="payoutFeePercentage"
						label="Insert Payout Fee Percentage"
						rules={[
							{
								required: true,
								message: 'Please input payout fee percentage!',
							},
						]}
					>
						<Input placeholder="e.g., 3" />
					</StyledFormItem>

					<StyledFormItem
						name="payoutFeeCapAmount"
						label="Insert Payout Fee Cap Amount"
						rules={[
							{
								required: true,
								message: 'Please input payout fee cap amount!',
							},
						]}
					>
						<Input placeholder="e.g., 3" />
					</StyledFormItem>

					<Form.Item>
						<Button type="primary" htmlType="submit" loading={loading}>
							{loading ? 'Creating...' : 'Create Payment Gateway'}
						</Button>
						<Button onClick={handleCancel} style={{ marginLeft: '8px' }}>
							Cancel
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</Card>
	);
};

export default PaymentGateway;
